import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteByIdController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteByIdController.php
* @route '/api/commission-note/{commission_note}'
*/
const GetCommissionNoteByIdController = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCommissionNoteByIdController.url(args, options),
    method: 'get',
})

GetCommissionNoteByIdController.definition = {
    methods: ["get","head"],
    url: '/api/commission-note/{commission_note}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteByIdController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteByIdController.php
* @route '/api/commission-note/{commission_note}'
*/
GetCommissionNoteByIdController.url = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { commission_note: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { commission_note: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            commission_note: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        commission_note: typeof args.commission_note === 'object'
        ? args.commission_note.id
        : args.commission_note,
    }

    return GetCommissionNoteByIdController.definition.url
            .replace('{commission_note}', parsedArgs.commission_note.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteByIdController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteByIdController.php
* @route '/api/commission-note/{commission_note}'
*/
GetCommissionNoteByIdController.get = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCommissionNoteByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CommissionNote\GetCommissionNoteByIdController::__invoke
* @see app/Http/Controllers/CommissionNote/GetCommissionNoteByIdController.php
* @route '/api/commission-note/{commission_note}'
*/
GetCommissionNoteByIdController.head = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCommissionNoteByIdController.url(args, options),
    method: 'head',
})

export default GetCommissionNoteByIdController